// packages/editor/src/studio/PreviewTab.tsx
//
// Renders the source markdown through applyFixture (path-inferred or
// default fallback) + the E1 ReadOnlyEditor. Updates live on source
// changes — Studio's tabbed parent re-mounts this component when the
// Preview tab is active and source changes.

import { useMemo } from 'react';
import { ReadOnlyEditor } from '../ReadOnlyEditor';
import { applyFixture, type Fixture } from '../fixtures/apply-fixture';
import { getDefaultFixture } from '../fixtures/default-fixture-loader';

export interface PreviewTabProps {
  source: string;
  /** Optional path-inferred fixture; falls back to default when absent. */
  fixture?: Fixture;
}

export function PreviewTab({ source, fixture }: PreviewTabProps) {
  const effectiveFixture = fixture ?? getDefaultFixture();
  const substituted = useMemo(
    () => applyFixture(source, effectiveFixture),
    [source, effectiveFixture],
  );

  return (
    <div data-testid="preview-tab" style={{ height: '100%', overflow: 'auto', padding: 16 }}>
      <ReadOnlyEditor key={substituted.length} markdown={substituted} />
    </div>
  );
}
